import React, { Component } from 'react';

import AboutUs from '../../components/Aboutus';
import Cabecalho from '../../components/Cabecalho';

// Blog Images
import ContactUs from '../../components/ContactUs';
import Events from '../../components/Events/Events';
import GoogleMap from '../../components/GoogleMap';
import TeamMembers from '../../components/TeamMembers';

export default class index extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    document.body.classList = '';
    // document.querySelector('.shoppingbtn').classList.add('btn-primary');
    window.addEventListener('scroll', this.scrollNavigation, true);
  }

  // Make sure to remove the DOM listener when the component is unmounted.
  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    var doc = document.documentElement;
    const navBar = document.getElementById('topnav');
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (navBar != null) {
      if (top > 80) {
        navBar.classList.add('nav-sticky');
      } else {
        navBar.classList.remove('nav-sticky');
      }
    }
  };
  render() {
    return (
      <React.Fragment>
        <Cabecalho />

        <section className="section bg-light">
          <a href="#about"></a>
          <AboutUs />
        </section>

        <section className="section">
          <a href="#calendar"></a>
          <Events />
        </section>

        {/* <section className="section bg-light">
          <a href="#noticias"></a>
          <Container className="mt-100 mt-60">
            <SectionTitle title="Ultimas Notícias" />

            <Row>
              <Noticias />
            </Row>
          </Container>
        </section> */}

        <section className="section pb-0 bg-light" id="contact">
          <a href="#equipa"></a>
          <TeamMembers />
        </section>

        <section className="section pb-0" id="contact">
          <a href="#contacto"></a>
          <ContactUs />
          <GoogleMap />
        </section>
      </React.Fragment>
    );
  }
}
